import { debounce } from 'lodash'
import { useCallback, useEffect, useRef } from 'react'

export const useLazyEffect = (effect, deps, wait = 300) => {
  const cleanUp = useRef()
  const effectRef = useRef()

  effectRef.current = useCallback(effect, deps)
  const lazyEffect = useCallback(
    debounce(() => (cleanUp.current = effectRef.current?.()), wait),
    [],
  )

  useEffect(lazyEffect, deps)
  useEffect(() => {
    return () => {
      effectRef.current instanceof Function ? cleanUp.current?.() : undefined
    }
  })
}
